import * as types from "../types";

const initState = {
  goTo: '',
  previouspage: "",
}


const NavReducer = (state = initState, action) => {
  switch (action.type) {
    case types.APP_NAVIGATE_TO:
      return {
        ...state,
        goTo: action.payload.goTo,
        previouspage: action.payload.previouspage || state.previouspage,// ? action.payload.previouspage : state.previouspage
      };

    default:
      return state;
  }
};

export default NavReducer;